import {NameId} from '@drl/core/models';

export class PhrCategory extends NameId {
  description: string;
}
